import { defineStore } from 'pinia'
// import queries from '@/graphql/craft/queries/index.js'

export const useStore = defineStore('mainStore', () => {
  const { locales, locale } = useI18n()

  const meta = ref({})

  // 'site' corrisponde alla lingua in Craft
  const site = computed(
    () => locales.value.find(({ code }) => locale.value === code)?.site,
  )

  // Restituisco la configurazione completa
  const configuration = computed(() => ({
    site: site.value,
    meta: meta.value,
  }))

  return {
    configuration,
  }
})
